import EmailInteractionStatsModal from 'components/Modals/EmailInteractionStats';

export const EmailStatisticsModal = ({ broadcast, ...modalProps }) => (
  <EmailInteractionStatsModal message={broadcast?.action} {...modalProps} />
);
